module.exports = __webpack_public_path__ + "img/personal.31dc87d1.png";